module.exports = __webpack_public_path__ + "static/img/brees-2005-top.6c90172.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2005-top.jpg
// module id = Wq7E
// module chunks = 1